import coverImg from "assets/images/v138/cover.webp"
import titleImg from "assets/images/v138/title.webp"

export const v138Config = {
  cover: {
    en: coverImg,
  },
  title: {
    en: titleImg,
  },
}
